import type { ColorPickerStateType } from './types.tsx';

export const COLOR_PICKER_STATE: Record<string, ColorPickerStateType> = {
	IDLE: undefined,
	EDIT: 'edit',
	CREATE: 'create',
};
